export enum ContentSectionType {
    Viewed,
    NotViewed,
}

export enum ContentType {
    Document = 'Document',
    Page = 'Page',
    Video = 'Video',
    Transcript = 'Transcript',
}

export enum EventType {
    Navigation = 'Navigation',
    Click = 'Click',
    Print = 'Print',
    Download = 'Download',
    AppLaunch = 'AppLaunch',
}
